import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Building2 } from "lucide-react";
import { api } from "../lib/api";

// Muestra la empresa activa con la que la IA generará el contenido.
export const ActiveCompanyBadge = () => {
  const [comp, setComp] = useState(undefined); // undefined=loading, null=none

  useEffect(() => {
    api.get("/companies").then((r) => {
      const list = r.data.companies || [];
      const active = list.find((c) => c.company_id === r.data.active_company_id) || list[0] || null;
      setComp(active);
    }).catch(() => setComp(null));
  }, []);

  if (comp === undefined) return null;

  if (!comp) {
    return (
      <Link to="/dashboard/empresas" data-testid="active-company-badge" className="inline-flex items-center gap-2 text-xs rounded-full border border-yellow-400/40 bg-yellow-400/5 px-3 py-1.5 text-yellow-impact hover:bg-yellow-400/10">
        <Building2 size={13} /> Selecciona una empresa para tu campaña
      </Link>
    );
  }

  return (
    <Link to="/dashboard/empresas" data-testid="active-company-badge" className="inline-flex items-center gap-2 text-xs rounded-full border border-purple-500/40 bg-purple-500/10 px-3 py-1.5 text-purple-200 hover:bg-purple-500/20">
      <Building2 size={13} /> Empresa activa: <strong className="text-white">{comp.name}</strong> · Cambiar
    </Link>
  );
};
